import { Button } from '@bwoty-web/ui-kit';

import "./priceOfferListLoader.scss";

const PriceOfferListLoader = () => {
  return (
    <div className="po-list-loader">
      {[1, 2, 3].map((x) => (
        <div className="po-list-loader-card" key={x}>
          <div className="po-list-loader-image" />
          <div className="po-list-loader-mobile-view-wrapper">
            <div className="po-list-loader-information-panel">
              <div className="po-list-loader-title po-list-fake-ui" />
              <div className="po-list-loader-rating po-list-fake-ui" />
              <div className="po-list-loader-subtitle po-list-fake-ui" />
              <div className="po-list-loader-usplist po-list-fake-ui" />
            </div>
            <div className="po-list-loader-price-panel">
              <div className="po-list-loader-price-wrapper">
                <div className="po-list-loader-price po-list-fake-ui" />
                <div className="po-list-loader-price-label po-list-fake-ui" />
              </div>
              <Button className="po-list-loader-button" disabled>
                <span />
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PriceOfferListLoader;
